export enum NewPlanStages {
    MODEL = 'model',
    PLAN = 'plan',
    VEHICLE_DETAILS = 'vehicle_details',
    USER_DETAILS = 'user_details',
    CUSTOMER_LINK = 'customer_link',
    CONGRATULATION = 'congratulation',
    REVIEW_DETAILS = 'review_details',
    IMEI = 'imei',
}

export const popularModels = [
    {
        id: 'find_x2',
        name: 'Find X2',
        image: '/assets/findx2.svg',
    },
    {
        id: 'regno7_pro_5g',
        name: 'Regno7 Pro 5G',
        image: '/assets/findx2.svg',
    },
    {
        id: 'regno6_pro_5g',
        name: 'Regno6 Pro 5G',
        image: '/assets/findx2.svg',
    },
    {
        id: 'f21_pro_5g',
        name: 'F21 Pro 5G',
        image: '/assets/findx2.svg',
    },
];

export enum DeviceCategory {
    MOBILE = 'mobile',
}

export const policyDetailsInitState = {
    customer: {
        name: '',
        phone: '',
        email: '',
        pincode: '',
    },
    device: {
        id: '',
        name: '',
        type: DeviceCategory.MOBILE,
        serial_number: '',
        purchase_date: '',
        delivery_date: '',
        price: null,
        brand: '',
    },
    document_urls: {
        invoice: '',
        imei: '',
    },
    document_names: {
        invoice: '',
        imei: '',
    },
    plan: {
        partner: '',
        plan_id: '',
        plan_name: '',
        purchase_date: '',
        program_id: '',
        premium: null,
        promo_name: '',
        plan_category: '',
    },
    policy_communication: true,
    order_communication: true,
    order_ekey: '',
};
